import React, { useEffect } from "react";

import { css, cx } from "@emotion/css";

import { useCanViewInclusionCenter, useInclusionCenterContent } from "@/hooks/useInclusionCenterContent.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { useIsMobileScreen } from "@/theme/responsive.ts";
import { PageDrawer } from "@/uiKit/atoms/page/PageDrawer.tsx";
import { useInclusionCenterDrawer } from "@/uiKit/atoms/page/PageDrawerState.ts";
import { InclusionCenterCard } from "@/uiKit/organisms/InclusionCenter/InclusionCenterCard.tsx";

export type InclusionCenterDrawerProps = {
  alignWithPageContent?: boolean;
  className?: string;
};

export const InclusionCenterDrawer: React.FC<InclusionCenterDrawerProps> = ({
  alignWithPageContent = false,
  className,
}) => {
  const styles = useStyles(makeStyles);
  const drawer = useInclusionCenterDrawer();
  const canViewInclusionCenter = useCanViewInclusionCenter();

  useEffect(() => {
    if (canViewInclusionCenter) {
      drawer.enable();
    } else {
      drawer.disable();
    }
  }, [canViewInclusionCenter, drawer]);

  if (!drawer.isEnabled) {
    return null;
  }

  return (
    <>
      <OpenInclusionCenter />
      <PageDrawer
        isOpen={drawer.isOpen && drawer.isEnabled}
        alignWithPageContent={alignWithPageContent}
        className={cx(styles.container, className)}
      >
        <InclusionCenterCard onClose={drawer.close} />
      </PageDrawer>
    </>
  );
};

const OpenInclusionCenter = () => {
  const inclusionCenterItems = useInclusionCenterContent();
  const drawer = useInclusionCenterDrawer();
  const isMobileScreen = useIsMobileScreen();

  useEffect(() => {
    if (inclusionCenterItems.length > 0 && !isMobileScreen && !drawer.touched) {
      drawer.open();
    }
  }, [inclusionCenterItems, isMobileScreen, drawer]);

  return null;
};

const makeStyles = (theme: Theme) => ({
  container: css({
    width: theme.spacing(196),
  }),
});
